import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import ProgressOverview from '../MeineAusbildung/ProgressOverview'
import ItemsToCheck from '#components/m/Uebersicht/ItemsToCheck'

import EmptyState from './UebersichtEmptyState'
import {routeHelper, routeKeys} from '#config/routeKeys'
import AusbildungsplanKachelListView from './AusbildungsplanKachelListView'
import {useNavigate} from 'react-router-dom'

function AusbildungsplanKachel({ausbildungsplanModel, showAllItems}) {
  if (!ausbildungsplanModel) {
    return <EmptyTile />
  }
  const navigate = useNavigate()

  const {items, totalCount} = ausbildungsplanModel

  const handleClick = ({azubiId, chapterId}) => {
    navigate(routeHelper.ausbildungsplanQuestionsChapter(azubiId, chapterId))
  }

  const redirect = () => navigate(routeKeys.uebersichtAusbildungsplan)

  return (
    <ProgressOverview titleKey="menu_item_ausbildungsplan" showProgressbar={false} testId="dashboard-ausbildungsplan">
      <ItemsToCheck itemText={i18n.t('uebersicht_ausbildungsplan')} itemValue={totalCount} />
      {totalCount === 0 ? (
        <EmptyState text={i18n.t('uebersicht_ausbildungsplan_empty')} />
      ) : (
        <AusbildungsplanKachelListView
          testId="kachellist-ausbildungsplan"
          data={items}
          totalCount={totalCount}
          handleClick={handleClick}
          showAllRedirect={redirect}
          showAllItems={showAllItems}
        />
      )}
    </ProgressOverview>
  )
}

function EmptyTile() {
  return (
    <ProgressOverview titleKey="menu_item_ausbildungsplan" showProgressbar={false} testId="dashboard-ausbildungsplan">
      <div data-testid="ausbildungsplanNoData" className="ausbildungsplan">
        <span>{i18n.t('loading_dashboard_data_failed')}</span>
      </div>
    </ProgressOverview>
  )
}

AusbildungsplanKachel.propTypes = {
  ausbildungsplanModel: PropTypes.shape({
    totalCount: PropTypes.number.isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        chapterId: PropTypes.string,
        azubiId: PropTypes.number,
        firstname: PropTypes.string,
        lastname: PropTypes.string,
      }),
    ),
  }),
  showAllItems: PropTypes.bool.isRequired,
}

export default AusbildungsplanKachel
